export const CommonUrl = {
    sales: '/sales',
    purchases: '/purchases',
    accounts: '/accounting/accounts',
    contacts: '/contacts',
    products: '/products',
    payment_terms: '/cp/terms',
    reports: '/reports',
    instruction: '/cp/instructions',
    tags: '/cp/tags',
};
